export const INELIGIBLE_REASONS = {
  unavailableState: 'unavailable_state',
  ineligibleAge: 'ineligible_age',
  accutane: 'using_accutane',
} as const;
